import PopoverComponent from "components/utils/popover";
import { useSelector } from "react-redux";

const HeaderComponent = () => {
  const { status } = useSelector((state) => state.auth);

  return (
    <>
      <div className="headerTop w-100 mb-2">
        <div
          className={`d-flex justify-content-end align-items-center ${
            status == "authenticated" ? "p-2" : "p-3"
          } pr-lg-5 `}
        >
          {status == "authenticated" && (
            <PopoverComponent content="Contenido del Popover"></PopoverComponent>
          )}
        </div>
      </div>
    </>
  );
};

export default HeaderComponent;
